export default "__VITE_ASSET__NcIyIKeY__"